/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `LocalizedDescriptionField` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/LocalizedDescriptionField
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
const LocalizedDescriptionField = ({
  descriptions,
  currentLanguage,
  onChange,
  getFieldValidationState,
  getFieldValidation,
  getErrorMessage,
  missingRequiredFields,
  t,
  styles,
}) => (
  <div className={styles.inputRow}>
    <div className={styles.fullWidthContainer}>
      <label className={styles.inputLabel}>
        {t("components.description.descriptionLabel")}
        {missingRequiredFields &&
          Object.hasOwn(missingRequiredFields, "descripcionDeLaEmpresa") && (
            <span className={styles.required}> *</span>
          )}
      </label>
      <div className={styles.descriptionInputWrapper}>
        <textarea
          className={`${styles.descriptionInput} ${
            getFieldValidationState(
              "description",
              descriptions[currentLanguage] || "",
            ) === "error" ||
            (getFieldValidation &&
              getFieldValidation("descripcionDeLaEmpresa"))
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.description.descriptionPlaceholder")}
          value={descriptions[currentLanguage] || ""}
          onChange={(e) => onChange(e.target.value)}
          maxLength={500}
        />
        <span className={styles.characterCounter}>
          {(descriptions[currentLanguage] || "").length}/500
        </span>
      </div>
      {getErrorMessage("description") && (
        <p className={styles.errorMessage}>{getErrorMessage("description")}</p>
      )}
    </div>
  </div>
);

export default LocalizedDescriptionField;
